import { render, staticRenderFns } from "./RtaDialog.vue?vue&type=template&id=76ecfc37&scoped=true"
import script from "./RtaDialog.vue?vue&type=script&lang=js"
export * from "./RtaDialog.vue?vue&type=script&lang=js"
import style0 from "./RtaDialog.vue?vue&type=style&index=0&id=76ecfc37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ecfc37",
  null
  
)

export default component.exports